<div class="wrapper">
    <!-- <app-webfacing-header *ngIf="!hideHeader"></app-webfacing-header> -->
    <app-webfacing-header-v2 *ngIf="!hideHeader" showGenerateReport="true"></app-webfacing-header-v2>
    <main>
        <app-trial-banner class="trial-banner-block"></app-trial-banner>
        <router-outlet></router-outlet>
    </main>
</div>